import { globalTheme } from "../../styles";

export const PrintIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = globalTheme.primaryColor } = props;

  return (
    <svg
      fill={fill}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      enableBackground="new 0 0 52 52"
      xmlSpace="preserve"
    >
      <g>
        <path d="M46.5,17.4h-41c-2.2,0-4,1.8-4,4v14c0,2.2,1.8,4,4,4h5.9l0,5.8c0,2.2,1.8,4,4,4h21.3c2.2,0,4-1.8,4-4l0-5.8 h5.9c2.2,0,4-1.8,4-4v-14C50.5,19.2,48.7,17.4,46.5,17.4z M8.3,27.7c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3s3,1.3,3,3 C11.3,26.4,10,27.7,8.3,27.7z M35.9,43.1c0,0.8-0.7,1.5-1.5,1.5h-17c-0.8,0-1.5-0.7-1.5-1.5v-9.8c0-0.8,0.7-1.5,1.5-1.5h17 c0.8,0,1.5,0.7,1.5,1.5V43.1z" />
        <path d="M40.5,11.1c0,0.8-0.7,1.5-1.5,1.5H12.8c-0.8,0-1.5-0.7-1.5-1.5V4.3c0-0.8,0.7-1.5,1.5-1.5H39 c0.8,0,1.5,0.7,1.5,1.5V11.1z" />
      </g>
    </svg>
  );
};
